import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { TemplateService } from './template.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-template-listing',
  templateUrl: './template-listing.component.html',
  styleUrls: ['./template-listing.component.css']
})
export class TemplateListingComponent implements OnInit {

    settingsForm!: FormGroup;


  currentPage: number = 1;
  statusArray: any = []
  AllocationFlag: any = false
  itemsPerPage: number = 25;
  totalItems: number = 0
  tableSize: number[] = [5, 10, 20, 50, 100];
  pagingConfig: any = {}
  pageNo: any;
  size: any;
  searchQuery: any = ''
  reminderCases: any = []
  currentCount: any = 0
  total: any = 0
  token: any
  storedData: any
  sortOrder: 'asc' | 'desc' = 'asc';
  sortField: string = ''; // Tra
  currentSortColumn: any = ''
  templates:any = []
  
  host: any;
  phoneNumber?: any;
  number?: any;
  version?: any;
  businessId?: any;
   open = false;
  showToken = false;
  settings:any = [];


  constructor(private loginService: LoginService, private router: Router,private templateService:TemplateService,
    private fb: FormBuilder
  ) {
    this.pagingConfig = {
      itemsPerPage: this.itemsPerPage,
      currentPage: this.currentPage,
      totalItems: this.totalItems
    }

  
     this.settingsForm = this.fb.group({
      from: ['', Validators.required],
      host: ['', [Validators.required]],
      port: ['', [Validators.required]],
      userName: ['', [Validators.required]],
      appPassword: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.token = localStorage.getItem('token');
    localStorage.removeItem('TemplateDetails')
    this.storedData = JSON.parse(localStorage.getItem("user") || '{}');
    this.listTemplates();
   
  }
  onTableSizeChange(event: any): void {
    this.pagingConfig.itemsPerPage = event.target.value;
    this.pagingConfig.currentPage = 1;
    this.size = event.target.value
    //  this.listReminderCases()

  }
  onTableDataChange(event: any) {
    this.pagingConfig.currentPage = event;
    //  this.listReminderCases()
  }

  close(){
     this.open = false;
     this.settingsForm.reset();
  }

  downloadTemplate(){
       this.templateService.downloadTemplate(this.token,{})
        .subscribe((response: any) => {

               if (response.data) {

                    console.log(response.data)
                     window.open(response.data,"_self")
                    
               }
        });
  }

  save(){
      console.log(this.settingsForm.value)

      if(this.settings.length){

        let info:any = this.settingsForm.value;
        info.id = this.settings[0]._id;
          
      this. templateService.updateSettings(this.token,info)
        .subscribe((response: any) => {

               if (response.status === 1) {

                   Swal.fire({
                    icon: 'success',
                    title: 'Saved Successfully',
                    text: `Saved`,
                  });

                  this.settingsForm.reset();
                  this.open = false;  
               }
             
        });


      }else{
       this.templateService.addSettings(this.token,this.settingsForm.value)
        .subscribe((response: any) => {

               if (response.status === 1) {

                   Swal.fire({
                    icon: 'success',
                    title: 'Saved Successfully',
                    text: `Saved`,
                  });

                  this.settingsForm.reset();
                  this.open = false;  
               }
             
        });
      }

  }

  openModal(){
     
       this.templateService.listSettings(this.token,this.settingsForm.value)
        .subscribe((response: any) => {

               if (response.status === 1) {
                  this.settings = response.data;
                  console.log(this.settings)

                  if(this.settings.length!=0){

                  let setArr = { "from": this.settings[0].from, 
                    "port": this.settings[0].port, 
                    "host": this.settings[0].host, 
                    "userName": this.settings[0].userName, 
                    "appPassword": this.settings[0].appPassword,}
                  this.settingsForm.setValue(setArr)
                  }
                  this.open = true;
               }
      });
      
  }

  toggleToken(e?: Event) {
    e?.stopPropagation();
    this.showToken = !this.showToken;
  }

    control(name: string) {
    return this.settingsForm.get(name)!;
  }
  //  ClientDetail(flag:any,obj:any){
  //    obj.flag=flag
  //    obj.type='reminder'
  //    localStorage.setItem('Work',JSON.stringify(obj))
  //    this.router.navigate(["/view-work"])

  //  }



  //  format(date:any){
  //   return moment(date).format(`DD-MM-YYYY \n \nHH:mma`);

  //  }


  openExcelUploadSwal(item:any) {
  Swal.fire({
    title: 'Upload Excel File',
    html: `
      <div style="text-align:left;">
       

        <label style="font-weight:600;">Upload Excel File:</label>
        <input type="file" id="excelFile" accept=".xlsx, .xls" class="swal2-input" style="width:70%;padding:5px;">
      </div>
    `,
    focusConfirm: false,
    confirmButtonText: 'Upload',
    showCancelButton: true,
    cancelButtonText: 'Cancel',
    preConfirm: () => {
      // const template = (document.getElementById('templateSelect') as HTMLSelectElement).value;
      const fileInput = document.getElementById('excelFile') as HTMLInputElement;
      const file = fileInput?.files?.[0];

    
      if (!file) {
        Swal.showValidationMessage('Please upload an Excel file.');
        return false;
      }

      return { item, file };
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const { template, file } = result.value!;
      console.log('Selected Template:', template);
      console.log('Uploaded File:', file);

      // ✅ Example: Upload file to backend
      const formData = new FormData();
      formData.append('file', file);
      formData.append('templateId', item._id);
       this.templateService.uploadExcelTemplate(this.token,formData)
        .subscribe((response: any) => {
          console.log(response)
          if (response.status === 1) {
              Swal.fire({
                icon: 'success',
                title: 'Mail sending started',
                text: '',
              });
          }
        });

      
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Uploaded Successfully',
      //   text: `Excel file uploaded for template: ${template}`,
      // });
    }
  });
}

  route() {
    this.router.navigate(["/template-mapping"])

  }

   listTemplates() {

     let req={
       searchKey:this.searchQuery,
 
       page:this.pagingConfig.currentPage,
       limit:this.pagingConfig.itemsPerPage
     }
  
      this.templateService.listTemplate(this.token,req)
        .subscribe((response: any) => {
          if (response.status === 100) {
            this.templates = response.data
            console.log(this.templates)
          }
        })
    }


  detail(item: any) {
    item.flag ='Edit'
    console.log(item)
    localStorage.setItem('TemplateDetails', JSON.stringify(item));

    this.router.navigate(["/template-mapping"])

  }


  deleteItem(item:any , index:any){
       
       Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        }).then((result) => {
          if (result.isConfirmed) {

            let req={
                id:item._id,
                isActive:false
                } 
           this.templateService.updateTemplate(this.token,req)
              .subscribe((response: any) => {

                if(response.status==1){

                  Swal.fire({
                    title: "Deleted!",
                    text: "Your template has been deleted.",
                    icon: "success"
                  });

                  this.listTemplates();
                }
            });
          }
        });
  }



  viewProgress(){
     this.router.navigate(['mailStatus'])
  }

  copyText(text: string) {
      // navigator.clipboard.writeText(text);
      // alert(`Copied: ${text}`);

       navigator.clipboard.writeText(text).then(
        () => {
            const Toast = Swal.mixin({
                  toast: true,
                  position: "center",
                  showConfirmButton: false,
                  timer: 1500,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                  }
                });
                Toast.fire({
                  icon: "success",
                  title: "Code copied to clipboard"
                });

        },
        (err) => {
          console.error('Could not copy text: ', err);
        }
      );
}



}
